import React from "react";
import { Box } from "@mui/material";

export interface BadgeProps {
  label: string;
  color: string; // hex — drives both text and (tinted) background
  icon?: React.ReactNode;
}

// A small rounded status/label pill. Background is a translucent tint of `color`.
const Badge: React.FC<BadgeProps> = ({ label, color, icon }) => (
  <Box
    component="span"
    sx={{
      display: "inline-flex",
      alignItems: "center",
      gap: 0.5,
      px: 1,
      py: 0.25,
      borderRadius: "10px",
      fontSize: "0.72rem",
      fontWeight: 600,
      whiteSpace: "nowrap",
      color,
      backgroundColor: `${color}1f`,
    }}
  >
    {icon}
    {label}
  </Box>
);

export default Badge;
